export const AppConstants = {
  SHELF_CLOSET_DEFAULT: "shelf",
  AGNOSTIC_FORM: "form",
  COUNTRY_US_CODE: "USA",
  COUNTRY_US_NAME: "United States",
  COUNTRY_CA_CODE: "CAN",
  COUNTRY_CA_NAME: "Canada",
  TEXT_OPTIN_YES: "Text Optin: Yes",
  TEXT_OPTIN_NO: "Text Optin: No",
  HOW_WE_CAN_REACH: "how-we-can-reach",
  REQUEST_TIME_TYPE: "request-time-section",
  CONTACT_US_ID: "contact-us",
  INSPECTION_FEE: "Inspection Fee",
  DIGNOSTIC_FEE: "Diagnostic Fee",
  CONTACT_US_TYPE: "contact-us-section",
  VEHICLE_REPAIR_ID: "vehicle-repair",
  SHELF_STORAGE_ID: "shelvingstorage",
  NO_CITY_FOUND: "No City Found",
  FIELD_ID_SERVICE_CATEGORY: "servicecategory",
  FIELD_ID_SERVICE: "service",
  FIELD_ID_SERVICE_TYPE: "servicetype",
  FIELD_ID_PRO_TYPE: "protype",
  FIELD_ID_PRICE_QUOTE_SELECTION: "pricequoteselection",
  FIELD_ID_MULTI_SERVICE_CATEGORY: "multiservicecategory",
  FIELD_ID_CAR_SERVICE_SELECTION: "carServiceSelection",
  PAYMENT_ID_SELECTION: "paymentSelection",
  PAYMENT_LABEL: "paymentLabel",
  PERSONAL_PAYMENT: "personalPayment",
  INSURANCE_PAYMENT: "insuranceClaim",
  GLASS_SERVICE_TYPE: "glass-service-type",
  MOBILE_ID_SELECTION: "mobile-service-selection",
  RESIDENTIAL_TEXT: "Residential",
  HOW_DID_YOU_HEAR_ABOUT_US_TEXT: "How did you hear about us",
  SECONDARY_SOURCE_TEXT: "Secondary Source",
  SERVICE_REQUEST_TEXT: "Service Request",
  SPECIAL_OFFER_TEXT: "Special Offer",
  ID_5UBM17_TEXT: "ID: 5ubm17",
  OTHER_TYPE: "Other",
  OTHER_TYPES: "Others",
  VIN: "VIN:",
  YEAR: "Year:",
  MAKE: "Make:",
  MODEL: "Model:",
  STYLE: "Style:",
  REPAIR_REPLACE: "Repair/Replace:",
  FEATURES: "Features:",
  MOBILE_SERVICE: "mobile-service-license",
  MOBILE_SERVICE_ADDRESS: "Mobile Service Address:",
  PAYMENT_METHOD: "Payment Method:",
  INSURANCE_COMPANY: "Insurance Compnay:",
  POLICY_NO: "Policy No:",
  DEDUCTABLE_AMOUNT: "Deductable Amount:",
  MOBILE_SERVICE_ID: "mobile-service-license",
  DROPOFF_SERVICE_ID: "dropoff-at",
  DIFFERENT_ADDRESS_ID: "different-address",
  MOBILE_ADDRESS: "mobile-address",
  MOBILE_ZIPCODE: "mobile-zipcode",
  INSURANCE_COMPANY_NAME: "insurance-company",
  POLICY_NUMBER: "policy-number",
  DEDUCTABLE_AMOUNT_VALUE: "deductible-amount",
  CHANGE_LOCATION_TITLE_DEFAULT_TEXT: "Choose a nearby location",
  CHANGE_LOCATION_MODAL_DEFAULT_DESCRIPTION: `Your ZIP/Postal Code is outside of our standard service area. Please
          choose from the list below of nearby locations.`,
  CHANGE_LOCATION_CTA_BUTTON_DEFAULT_TEXT: "SELECT",
  SERVICE_CATEGORIES_NOTE: "Service Categories:",
  COUNTRY_US: "us",
  COUNTRY_CA: "ca",
  VIN_NUMBER_LENGTH: 17,
  BUSINESS_NAME: "businessname",
  SERVICE_INFORMATION: "service-information",
  VEHICLE_INFORMATION_SECTION: "vehicle-information-section",
  COMMERCIAL_TEXT: "commercial",
  IS_AUTO_FLOW: "isAutoFlow",
  EMAIL_OPT: "Email OptIn",
  EMAIL_ID: "email",
  ZIPCODE_ID: "zipcode",
  BOOK_AN_INSPECTION: "book-an-inspection",
  INSPECTION_FEE_WITHOUT_ZIPCODE: "inspection_fee_without_ZipCode",
  WARRANTY_TEXT: "Warranty",
  NO_STATE_FOUND: "No State Found",
  EXISTING_CUSTOMER: "existingcustomer",
  SERVICE_BOT_SECTION: "service-bot-section",
  PAYMENT_IFRAME_SECTION: "paymentIframe",
  SELECTED_SERVICE: "Selected Service",
  PAYMENT_API_IFRAME_SECTION: "paymentApiIframe",
  SPECIAL_OFFER_POPUP_TRACKING_CODE: "BookedPop",
  PRICING_CART_LIST: "pricingCartList",
  FINANCING_INTEREST: "financingInterest",
  ISN: "ISN",
  AUTO_TEXT: "auto",
};

export const VEHICLE_PAGE_IDS = {
  FIELD_ID_FIND_VEHICLE: "find-vehicle-vin",
  FIELD_ID_FIND_LICENSE: "find-vehicle-license",
  FIELD_ID_LICENSE: "license",
  period: 10000,
  BARCODE_ID: "find-barcode",
  FIELD_ID_MODEL_YEAR: "modelYear",
  TAB_ID_MANUAL: "manual",
  FIELD_ID_VIN: "vin",
};

export const VIN_LABELS = {
  VIN_LABEL: "VIN: ",
  YEAR_LABEL: "Year: ",
  MAKE_LABEL: "Make: ",
  MODEL_LABEL: "Model: ",
  STYLE_LABEL: "Style: ",
};

export const FIELD_ERROR_MSG = "Please fill out all required fields";

export const RegexConstants = {
  PHONE_REG: /(\d{0,3})(\d{0,3})(\d{0,4})/,
  EMAIL_REG:
    /^(([^<>()[\]\\.,;:\s@"#]+(\.[^<>()[\]\\.,;:\s@"#]+)*)|("[^"]+"))@((\[(25[0-5]|2[0-4]\d|1\d\d|\d{1,2})(\.(25[0-5]|2[0-4]\d|1\d\d|\d{1,2})){3}\])|(([a-z\d]([a-z\d\-]*[a-z\d])?\.)+[a-z]{2,}))$/i, // Email Address
  FIRST_LAST_NAME_REG:
    /^(?=[A-Za-z])(?!.*[+(),*])(?=[^-.']*(?:[-.'][^-.']*){0,2}$)(?=[^ ]*(?: [^ ]*){0,2}$)[A-Za-z][A-Za-z'-. ]*$/,
  ZIP_CODE_REG:
    /^\d{5}$|^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$|^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/,
  US_CA_ZIP_CODE_REG: /(^[A-Za-z]\d[A-Za-z]( ?\d[A-Za-z]\d)?$)|(^\d{5}$)/,
  CA_ZIP_CODE_REG: /^[A-Za-z]\d[A-Za-z]( ?\d[A-Za-z]\d)?$/,
  US_ZIP_CODE_REG: /^\d{5}(-\d{4})?$/,
  ADDRESS_REG: /^[^!@#$%^&*()].*$/,
  CITY_NAME:
    /^(?=[A-Za-z])(?!.*[+(),*])(?=[^-.']*(?:[-.'][^-.']*){0,2}$)(?=[^ ]*(?: [^ ]*){0,2}$)[A-Za-z][A-Za-z'-. ]*$/,
};

export const sharedStateKeys = {
  PRICE_QUOTE_SELECTION_DETAILS: "priceQuoteSelectionDetails",
  CES_DYNAMIC_MENU_API_DATA: "cesDynamicMenuApiData",
  IS_PRICE_QUOTE_PAGE: "isPriceQuotePage",
  S_STATE_CHANGE_NEAR_BY_LOCATION: "changeNearByLocation",
  S_STATE_ADDRESS_SUGGESTION_RES: "ADDRESS_SUGGESTION_RES",
  CHILD_ERRORS: "childErrors",
  SELECTED_SERVICE_IDS: "selectedServiceIds",
  IS_PRICING_AVAILABLE: "isPricingAvailable",
  MULTIPLE_DOMAINS: "multiDomains",
  SERVICE_CATEGORY: "serviceCategory",
  IS_QUOTE_CARD_VISIBLE: "IS_QUOTE_CARD_VISIBLE",
  IS_SERVICE_SKU_FIELD_AVAILABLE: "isServiceSKUFieldAvailable",
  CATEGORY_BASED_QAS_FOR_INITIAL_RENDER: "categoryBasedQAsForInitialRender",
  PRICE_QUOTE_ESTIMATION_OBJECT: "estimationObject",
  NON_PRICABLE_QUOTE_ESTIMATION_OBJECT: "nonPricableEstimationObject",
  BOOK_AN_INSPECTION_ENABLE: "bookAnInspection",
  IS_WARRANTY: "iswarranty",
  DISCLAIMER_TERMS: "terms",
  IS_PAUSE_LEAD: "isPauseLead",
  ALTERNATE_CONCEPT: "alternateConcept",
  SHOW_PROTECT_PROPERTY_LOGO: "showProtectPropertyLogo",
  LOCALISED_LOGO: "localisedLogo",
  SET_UPLOADED_IMAGES: "setUploadedImages",
  SERVICE_REQUEST_TYPE: "serviceRequestType",
  SERVICE_REQUEST_PROPERTY: "serviceRequestProperty",
  SERVICE_REQUEST_ID: "serviceRequestId",
  PRICING_CONFIG: "pricing_config",
  MODIFIER_FLOW_ID: "modifierFlowId",
  PRICING_RANGE: "pricingRange",
  IS_TECH_AVAILABLE_FAILS: "isTechAvailableFails",
  REMAINING_WEEKS: "remainingWeeks",
  CALENDAR_IN_WEEKS: "calendarInWeeks",
  IS_INTERACTIVE_MAP_READY: "isInteractiveMapReady",
  IS_TRENDING_SERVICE_READY: "isTrendingServiceReady",
  IS_SERVICE_PAGE_SKIPPED: "isServicePageSkipped",
};

export const stepTypes = {
  STEP_PRICE_QUOTE_REQUEST: "price-quote-request",
  STEP_PRICE_QUOTE_ESTIMATION: "price-quote-estimation",
  HOW_WE_CAN_REACH: "how-we-can-reach",
  PAYMENT_IFRAME: "paymentIframe",
  CONTACT_US: "contact-us-section",
  REQUEST_TIME_TYPE: "request-time-section",
};

export const ALLOWED_EXTENSIONS = ["jpeg", "jpg", "png"];
export const MAX_FILE_SIZE_MB = 5 * 1024 * 1024;

export const PRICE_QUOTE_VALUE_NO = "no";

export const conceptIDs = {
  MLY_CONCEPT_ID: "1",
  FSP_CONCEPT_ID: "4",
  MDG_CONCEPT_ID: "5",
  WDG_CONCEPT_ID: "16",
  DVW_CONCEPT_ID: "24",
  MRA_CONCEPT_ID: "8",
  LAP_CONCEPT_ID: "29",
  JUK_CONCEPT_ID: "30",
  HMS_CONCEPT_ID: "25",
  RPM_CONCEPT_ID: "17",
};

export const conceptCodes = {
  WDG_CONCEPT_CODE: "WDG",
  FSP_CONCEPT_CODE: "FSP",
  DVW_CONCEPT_CODE: "DVW",
  MRA_CONCEPT_CODE: "MRA",
  JUK_CONCEPT_CODE: "JUK",
  MLY_CONCEPT_CODE: "MLY",
  MDG_CONCEPT_CODE: "MDG",
  PLG_CONCEPT_CODE: "PLG",
  HMS_CONCEPT_CODE: "HMS",
  RPM_CONCEPT_CODE: "RPM",
};

export const optInTextLabel = {
  TEXT_OPT_IN_LABEL: "Text Opt-in:",
  EMAIL_OPT_IN_LABEL: "Email Opt-in:",
};

export const formActionButtonTypes = {
  SUBMIT: "submit",
  BACK: "back",
  BACK_WITH_LESS_THAN_ARROW_ICON: "backWithLessThanArrowIcon",
  SKIP: "skip",
  WINDOW_CALL_LINK: "windowCallLink",
  CONTACT_ME: "contactMe",
};

export const quoteConstants = {
  QUOTE_SUMMARY: "Estimate Summary",
  SUB_TOTAL: "Subtotal",
  SERVICE_MINIMUM: "Service Minimum",
  TOTAL_ESTIMATED_AMOUNT: "Total Estimated Amount*",
  NO_QUOTE_MESSAGE:
    "Based on the service(s) selected, an estimate cannot be provided at this time. A Window Genie team member will contact you to assess your service needs.",
};

export const noAddressMsg = "No address collected";

export const windowCallLink = "Have Window Genie Call";

export const showLessText = "Show Less";
export const SELECT_ALL_TEXT = "Select All";
export const DESELECT_ALL_TEXT = "Deselect All";

export const SUMBIT_AND_CONTINUE_BUTTON_TEXT = "Submit and Continue";
export const SAVE_AND_CONTINUE = "Save and Continue";
export const BACK_BUTTON_TEXT = "Back";

export const SESSION_INSPECTION_FEE_VALUE = "inspectionFeeValue";

export const SESSION_INSPECTION_FEE_DATA = "inspectionFeeData";
export const ONLY_SUBMIT_BTN_TEXT = "Submit";
export const SCHEDULE_SERVICE = "Schedule Service";

export const maxReadTextLength = 120;

export const maxFilesUploaded = "You've reached the maximum file upload.";
export const Browse = "Browse";
export const SUBMIT_AND_ADD_PAYMENT = "Submit and Add Payment";

export const PROTYPE_COMMERCIAL_TEXT = "Commercial";

export const NO_SERVICES_MESSAGE =
  "No services currently selected. Please return to previous screen to select at least once service.";

export const ADD_SERVICES_BTN_TEXT = "Add Services";

export const carImage = `${window.location.origin}/brand/_assets/images/brand-img/vehicle-structure.svg`;

export const stateAbbreviations: Record<string, string> = {
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
  Alberta: "AB",
  "British Columbia": "BC",
  Manitoba: "MB",
  "New Brunswick": "NB",
  Newfoundland: "NF",
  "Northwest Territories": "NT",
  "Nova Scotia": "NS",
  Nunavut: "NU",
  Ontario: "ON",
};

export const FORM_VALUES_KEYS = {
  CATEGORY_BASED_QAS: "categoryBasedQAs",
};

export const errorMessages = {
  ERROR_MSG_EMPTY_VIN_INPUT: "Please fill the VIN field",
};

export const NDRP_SECTION_IDS = {
  NDRP_SECTION_ID: "confirmation-done-right-box",
  NDRP_SECTION_IMG_URL_ID: "done-right-logo",
  NDRP_SECTION_TITLE_ID: "done-right-title",
  NDRP_SECTION_DESC_ID: "done-right-para",
};

export const VIN_MODAL_TITLE = "Where's My VIN?";
export const VIN_MODAL_DESC =
  "Your VIN can be found on the inside of the driver’s side on the door jamb.";

export const NAME_CATEGORY_BASED_QA_PREFIX = "categoryBasedQAs_";

export const MOB_TOOLTIP_TITLE = "Do My Windows Have Grids?";
export const SESSION_FORMVALUES = "formValues";
export const SESSION_CORRELATIONID = "correlationId";
export const SESSION_QUOTE_ESTIMATE = "quoteEstimation";
export const IS_PRICING_AVAILABLE = "isPricingAvailable";
export const SESSION_NON_PRICEABLE_QUOTE_ESTIMATE =
  "nonPriceableQuoteEstimation";
export const SESSION_FILEURLS = "fileUrls";
export const SESSION_PRIMARYSOURCE = "primarySource";
export const SESSION_SELFSTORAGE = "shelfStorage";
export const SESSION_CALENDARFLOW = "calendarFlow";
export const PREFERRED_APPOINTMENT = "Preferred Appointment Time:";
export const SELECTED_SLOT = "Selected date and time:";
export const SELECT_SLOT_MESSAGE = "Please Select a Time";
export const SELECT_SLOT_ERROR = "Please select a slot before proceeding";
export const ATOM_PI_KEY = "63cd35856abc51483699f59f167df20e";
export const PRICING_ID = "servicePricingTabs";

export const NBLY_DEV = "nblydev";
export const NBLY_TEST = "nblytest";
export const NBLY_PROD = "nblyprod";

export const SERVICES = {
  SKU: "Service Sku",
  GROUP: "Service Group",
};
export const SESSION_FILES = "files";
export const SESSION_TEXT_TILES = "textTiles";

export const LOCAL_HEADER_LOGO_ID = "local-header-logoimagepath";

export const SESSION_FILES_UPLOAD = "filesUpload";
export const SELECTED_PRICE_QUOTE_SKU_IDS = "selectedPriceQuoteSkuIds";
export const EXISTING_CUSTOMER_NOTE = "Existing Customer";
export const ZIP_CODE_VALIDATION_ERROR = "Zip/Postal Code";

export const serviceDetailsLabels = {
  SERVICE_SELECTED: "Service Selected",
  SERVICE_FOR: "Service For",
  MESSAGE: "Message",
  APPLIANCE_BRAND: "Appliance Brand",
  APPLIANCE_WELLNESS_PROGRAM_SUBCRIPTION:
    "Appliance Wellness Program Subcription",
  WARRANTY: "Warranty",
  LEAD_SOURCE_TEXT: "Lead Source",
  FLOOR_LABEL: "What floor is the appliance located?",
  BUSINESS_NAME_TEXT: "Business Name",
  SERVICE_TYPE: "Service Type",
  PROTYPE_TEXT: "ProType",
  SERVICE_TEXT: "Service",
  SERVICE_CATEGORY_NAME: "ServiceCategory",
};

export const mlyLabels = {
  MLY_PRICE: "Price",
  FREQUENCY: "MLY Frequency",
  SQ_FT: "Square Feet",
  BEDROOMS: "Bedrooms",
  OFFICES: "Offices",
  BATHROOMS: "Bathrooms",
};

export const MULTIPLE_LOCATIONS_ERROR_MSG =
  "Full address is needed to narrow down results";
export const ADDRESS_BUMPER_FORM_MODAL_ID = "address-bumbper-form-modal";
export const ADDRESS_BUMPER_DESCRIPTION =
  "we found a similar address in our database. Please ensure that your recipient's address is correct. Then select the address you wish to use.";
export const SUGGESTED_ADDRESS = "Suggested Address";

export const SKELETON_LOADER_LAYOUT_PAGE = "page";
export const SKELETON_LOADER_LAYOUT_FORM = "form";
export const SEKELETON_LOADER_LAYOUT_CARDS = "cards";
export const SUGGEST_ADDRESS_VALUE = "suggestedAddressValue";

export const SESSION_UPSELL = "isUpsellVisible";
export const SESSION_CROSS_SELL = "isCrossSellVisible";

export const UPSELL_VARIABLES = {
  UPSELL_TITLE: "upsell-title",
  UPSELL_PARA: "upsell-para",
  UPSELL_LIST: "upsell-list",
  UPSELL_REQUEST_QUOTE_BTN: "request-quote-btn",
  UPSELL_READ_MORE: "Read More",
  UPSELL_NOTES_TEXT: "You will receive more information on",
  ADDITIONAL_SERVICES: "Additional Service(s)",
  MAX_ITEMS_TO_SHOW: 4,
  SESSION_UPSELL_SERVICE_DEC: "serviceDescription",
  UPSELL_PAYLOAD_KEY: "Upsell-confirmation",
};

export const EMAIL_VALIDATION_ERROR = "must be a valid email address";

export const SESSION_EMAIL_VALIDATION_ERROR = "emailValidationError";

export const IS_CONTACT_ME_BUTTON = "contactMeButton";

export const CONTACT_ME_BUTTON_TEXT = "Contact Me";
export const ERROR_PRICING_MODAL = "errorPricingModal";

export const showMoreText = "Show More";
export const JUK_DUMPSTER_RENTAL_CTA_ID = "dumpster-tc";
export const DEFAULT_FRANCHISE_ID = "930";
export const CustomerRecordUpdatedText = "Customer record updated in database";
export const CustomerSuccessfullyAddedText =
  "Customer successfully added to database";

export const CONTACT_ADD_NOTE = "Mobile Service at Customer Contact Address";
export const MOBILE_ADD_NOTE = "Mobile Service";

export const HOW_MANY_WEEKS_TO_DISPLAY = 3;
export const JK_CONFIRMATION_LABEL = "JK Confirmation #";

export const AVAILABILITY = "No availability";
export const AVAILABLE_TIME = "Available times for";
export const DEBOUNCE_DELAY = 150;

export const MLY_IDS = {
  MLY_HOME_PROPERTY_SQ_FT: "square-feet",
  MLY_OFFICE_PROPERTY_SQ_FT: "office-square-feet",
  MLY_RES_BEEDROOMS: "bedrooms",
  MLY_RES_BATHROOMS: "bathrooms",
  MLY_COM_OFFICES: "offices",
  MLY_COM_BATHROOMS: "commercial-bathrooms",
  SERVICE: "cleaning-service",
  FREQUENCY: "frequency-of-cleaning",
  COMMERCIAL_FREQUENCY: "commercial-frequency",
  MOVE_IN_OUT_CLEAN: "Move In or Move Out Clean",
  NOT_MOVE_IN_OUT_CLEAN: "Not a Move In or Move Out Clean",
  MOVE_IN_OUT_CLEANING_OPTION: "move-in-out-cleaning-option",
  ONE_TIME_CLEANING_OPTION: "one-time-cleaning-option",
  ONE_TIME_CLEAN: "one-time-clean",
  RECURRING_CLEAN: "recurring",
  COMMERCIAL_ONE_TIME_CLEAN: "commercial-one-time-clean",
  COMMERCIAL_RECURRING: "commercial-recurring",
  COMMERCIAL: "commercial",
  RESIDENTIAL: "residential",
  ONE_TIME_CLEAN_ID: "one-time-clean-type",
  ONE_TIME_CLEAN_OPTION: "one-time-cleaning-option",
  COMMERCIAL_MOVE_CLEAN: "commercial-move-clean",
  RECURRING: "Recurring",
  ONE_TIME: "One-time",
  NO_CALENDAR_PRICING: "No Calendar Pricing",
};

export const MLY_SERVICE_TEXT = {
  LEAD_ONLY: "Lead Only",
  ESTIMATE: "Estimate",
  ONE_TIME_CLEAN: "One Time Clean",
};

export const OFFER_COMPONENT_CONSTANTS = {
  OFFER_ATTACHED_TEXT: "Offer Attached",
  OFFER_REMOVED_TEXT: "Offer removed due to change in zip code",
  OFFER_DROPPED_SERVICE_TYPE_TEXT:
    "Offer dropped due to change in service type",
};

export const JUKServices = {
  DUMPSTER_RENTAL: "Dumpster Rental",
  FULL_SERVICE_JUNK_REMOVAL: "Full Service",
};

export const enabledConcepts = [
  conceptCodes?.JUK_CONCEPT_CODE,
  conceptCodes?.MDG_CONCEPT_CODE,
];

export const LONG_DISCRIPTION =
  "TEST Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nunc ut laoreet cursus, enim erat facilisis urna, nec dictum enim enim euismod enim. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam at risus et justo dignissim congue. Donec congue lacinia dui, a porttitor lectus condimentum laoreet. Nunc eu ullamcorper orci. Quisque eget odio ac lectus vestibulum faucibus eget in metus.";
export const SESSION_SERVICE_API_ERROR = "serviceApiError";
export const mapZoomLevel = 15;
export const PROPERTY_AREA_CONFIRMATION = "propertyAreaConfirmation";

export const FSPBusinessServiceType = "business";
